import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
import { SelectItem } from 'primeng/api';
import { VinsBuquesService } from '../servicios/vins-buques.service';
import { AveriasService } from '../servicios/averias.service';
import * as XLSX from 'xlsx';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { vinsVisita, vinsVisitaDTO, visitaExistenteDTO } from '../entidades/entidades.component';
import { SnackBarComponent } from '../snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NbDialogService } from '@nebular/theme';
import { VinsBuquesPopupValidExpoComponent } from './vins-buques-popup-valid-expo/vins-buques-popup-valid-expo.component';
import { AnalyticsService } from '../servicios/analytics.service';
import { ChangeTabsService } from '../servicios/change-tabs.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { VinsBuquesModifComponent } from './vins-buques-modif/vins-buques-modif.component';
import { VinsBuquesConsultaComponent } from './vins-buques-consulta/vins-buques-consulta.component';

import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';


@Component({
    selector: 'app-vins-buques',
    templateUrl: './vins-buques.component.html',
    styleUrls: ['./vins-buques.component.css'],
    providers: [
        DatePipe
    ],
    standalone: true,
    imports: [VinsBuquesConsultaComponent, VinsBuquesModifComponent, FormsModule, MatIconModule,
       CommonModule, NbCardModule, NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, 
       MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, MatNativeDateModule, 
       NbSelectModule, NbTreeGridModule, SpinnerComponent, MultiSelectModule, 
      AgGridAngular],
    
})
export class VinsBuquesComponent implements OnInit {
  idCliente: number;
  file
  fileName:string=""
  durationInSeconds = 3;
  diaHoy = new Date();
  diaTomorrow = new Date(new Date().setDate(new Date().getDate() + 2));

  showSpinnerGuardar = false;

  showSpinnerUpload = false;

  visitaNoExiste:boolean = false;
  cargoArchivo:boolean = false;

  habilitarGuardar:boolean = false;
  habilitarProceso:boolean = false;
  habilitarUpload:boolean = false;

  buqueAltaSelected:number = 0;
  buquesAlta: SelectItem[];
  buquesAltaMOCK = [];

  operadorAltaDescSelected;
  operadorAltaSelected:number =0;
  operadoresAlta: SelectItem[];
  operadoresAltaData: [];

  habilitarOperador:boolean =false;

  procesoAltaSelected;
  procesosAlta: SelectItem[];
  procesosAltaMOCK = [];


  codigoVisita;
  fechaAltaETA = null;
  fechaAltaATA = null;
  fechaAltaETD = null;
  fechaAltaATD = null;
  
  vinsDeLaVisita: vinsVisita[] = [];
  dataVinsAlta: any = [];
  angularGridVinsAlta: AngularGridInstance;
  columnDefinitionsVinsAlta: ColDef[];//Column[];
  gridOptionsVinsAlta: GridOption;
  showGridAlta = false;
  ocultarFechas = true;
  elemFiltered;
  totalReg;
  tabActivo;

  @ViewChild('grilla1') grilla1!: AgGridAngular;

  constructor(private dateFormatter: DatePipe, private adapter: DateAdapter<any>,
    private svcVinsBuq: VinsBuquesService, private svcAverias: AveriasService,
    public usersRol: PerfilesUsuarioService, private _snackBar: MatSnackBar,
    private dialogService: NbDialogService, private changeVinsBuques: ChangeTabsService,
    private svcAnalytics: AnalyticsService) { }

  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'))
    this.changeVinsBuques.tabVinsBuques.subscribe(data => {
      this.tabActivo = data;
    })
    this.inicio();
    this.adapter.setLocale('es-MX');
    this.svcAnalytics.setAnalyticsPageView();
  }
  angularGridReadyVinsAlta(angularGrid: AngularGridInstance) {
    this.angularGridVinsAlta = angularGrid;
    this.angularGridVinsAlta.resizerService.pauseResizer(false)
  }
  habilitarBotonGuardar(){
    if (this.cargoArchivo && this.visitaNoExiste)
      this.habilitarGuardar = true;
    else
      this.habilitarGuardar = false;
  }
  onChangeTab(event){
      this.changeVinsBuques.changeVinsBuques(event.tabTitle)
  }
  inicio(){
    //INICIALIZO BUQUES
    this.svcAverias.getBuques().subscribe(
      data => {
        this.buquesAltaMOCK = data.content;
        this.buquesAlta = this.insertarOperadores(this.buquesAltaMOCK)
    });

    //INICIALIZO OPERADORES
    this.svcAverias.getOperadoresVisita().subscribe(
      data => {
        this.operadoresAltaData = data.content;
        this.operadoresAlta = this.insertarOperadores(this.operadoresAltaData)
    });
    //INICIALIZO PROCESOS
    this.svcAverias.getTipoProcesosVisita().subscribe(
      data => {
        this.procesosAltaMOCK = data.content;
        this.procesosAlta = this.insertarProcesos(this.procesosAltaMOCK)
      }
  )};
  insertarBuques(arrBuques) {
    let buquesDisponibles: Array<any> = [];
    arrBuques.forEach(element => {
      buquesDisponibles.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return buquesDisponibles;
  };
  insertarOperadores(arrOpe) {
    let operadoresDisponibles: Array<any> = [];
    arrOpe.forEach(element => {
      operadoresDisponibles.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return operadoresDisponibles;
  };
  insertarProcesos(arrProcesos) {
    let procesosDisponibles: Array<any> = [];
    arrProcesos.forEach(element => {
      procesosDisponibles.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return procesosDisponibles;
  };
  initFrmAlta(){
  }
  cargarGrillaAlta(){
    this.showGridAlta = false;
    this.cargoArchivo= false;

    let mockDataset: any= [];
    this.vinsDeLaVisita = [];
    this.dataVinsAlta =[];
    var columns=[];
    var keys = Object.keys(this.file[0]);
    keys.forEach( function(key) {
      columns.push(key);
    })

    if (columns.length < 2){
      alert("El archivo debe contener como minimo 2 columnas")
      this.fileName = "";
      this.showSpinnerUpload = false;
      return
    }

    if (columns.length > 4){
      alert("El archivo debe contener como maximo 4 columnas")
      this.fileName = "";
      this.showSpinnerUpload = false;
      return
    }

    for (let i = 0; i < this.file.length; i++) {
      mockDataset.push({
        id: i,
        VIN: this.file[i][columns[0]],
        OrigenDestino: this.file[i][columns[1]],
        // nfactura: this.file[i][columns[2]],
        // bl: this.file[i][columns[3]]
        // VIN: this.file[i]["vin"],
        // OrigenDestino: this.file[i]["origen"],
        nfactura: this.file[i]["factura"],
        bl: this.file[i]["bl"]
      });
      this.vinsDeLaVisita.push({
        vin: this.file[i][columns[0]],
        destinoOrigen: this.file[i][columns[1]],
        numeroFactura: this.file[i]["factura"],
        bl: this.file[i]["bl"]
      })
    }

    //hacer las pruebas aca
    this.ValidarVinsVisitasAbiertas(this.vinsDeLaVisita.map(({ vin }) => vin));

    if (this.procesoAltaSelected == 2){
      this.validarInspeccionesExistentes(this.vinsDeLaVisita.map(({ vin }) => vin));
    }
    else {
      this.showSpinnerUpload = false;
    }
    this.showGridAlta = true;
    this.cargoArchivo= true;
    this.dataVinsAlta = mockDataset;
    this.totalReg = this.dataVinsAlta.length;
  }

    ValidarVinsVisitasAbiertas(vins: string[]){  
    this.svcAverias.vinsExistentesenVisita(this.idCliente,vins, "0" ).subscribe(
      data => {
        if (data["status"] == 200) {
          if (data["body"].length > 0){
             this.openVinsIspeccDialog(data["body"],"Los siguientes VINS ya tienen asociadas otras visitas activas",'VINS CON VISITAS ABERTAS');
             this.openSnackBar('Error al dar de alta listado de unidades, existen unidades asociadas a otras visitas activas');
             this.habilitarGuardar = false;
          }
          else
            this.openSnackBar('Los datos se han validado correctamente');
         
        } else {
          this.openSnackBar('Ha ocurrido un error al validar los datos.');
        }
        this.showSpinnerUpload = false;
      }, error=>{
        this.openSnackBar('Ha ocurrido un error al validar los datos');
        this.showSpinnerUpload= false;
      }
    )
  }


  validarInspeccionesExistentes(vins: string[]){  
    this.svcAverias.vinsConInspeccionPrevia(this.idCliente,vins).subscribe(
      data => {
        if (data["status"] == 200) {
          if (data["body"].length > 0){
            this.openVinsIspeccDialog(data["body"],"Los siguientes VINS no tienen inspecciones previas","VINS SIN INSPECCION")
          }
          this.openSnackBar('Los datos se han validado correctamente');
        } else {
          this.openSnackBar('Ha ocurrido un error al validar los datos');
        }
        this.showSpinnerUpload = false;
      }, error=>{
        this.openSnackBar('Ha ocurrido un error al validar los datos');
        this.showSpinnerUpload= false;
      }
    )
  }
  ingresarDatosGrillaAlta(){
    this.columnDefinitionsVinsAlta = [
      { //7id: 'VIN', 
        headerName: 'VIN', field: 'VIN', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'OrigenDestino', 
        headerName: 'Origen/Destino', field: 'OrigenDestino', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
      { //id: 'nfactura', 
        headerName: 'Factura', field: 'nfactura', sortable: true, filter: true, floatingFilter: true, minWidth: 60, width: 60, },
      { //id: 'bl', 
        headerName: 'BL', field: 'bl', sortable: true, filter: true, floatingFilter: true, minWidth: 60, width: 60, },
    ];
    this.gridOptionsVinsAlta = {
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
  }
  resetearValores(){
    this.procesoAltaSelected = null;
    this.operadorAltaSelected = null;
    this.ocultarFechas = true;
    this.cargoArchivo = false;
    this.visitaNoExiste = false;
    this.fileName = "";
    this.dataVinsAlta = [];
    this.showGridAlta = false;
    this.habilitarUpload = false;
    this.codigoVisita = null;

    this.habilitarBotonGuardar();
  }

  resetearValoresGuardar(){
    this.procesoAltaSelected = null;
    this.operadorAltaSelected = null;
    this.ocultarFechas = true;
    this.cargoArchivo = false;
    this.visitaNoExiste = false;
    this.fileName = "";
    this.dataVinsAlta = [];
    this.showGridAlta = false;
    this.habilitarUpload = false;

    this.habilitarBotonGuardar();
  }
  changeOperadorAlta(ope) {
    this.validarVisitaExistente();
    this.habilitarProceso = true;
  }
  changeBuqueAlta(buque) {
    this.habilitarOperador =true;
    this.operadorAltaDescSelected = this.buquesAltaMOCK.find(n=> n.id == this.buqueAltaSelected).operador
    this.resetearValores();    
  }
  changeCodVistaExt(eve){
    if(eve != "" && this.buqueAltaSelected !=0) {
      this.validarVisitaExistente()
    } else {
      this.habilitarProceso = false;
      this.habilitarGuardar = false;
    }
  }
  changeProcesoAlta(ope) {
  
    this.validarVisitaExistente();
    this.ocultarFechas = false;
    this.habilitarBotonGuardar()
  }
  validarVisitaExistente(){
        // VALIDAR EL BUQUE-TIPO PROCESO- FECHA NO ESTE DADO DE ALTA
        var visita: visitaExistenteDTO = {
          idBuque: this.buqueAltaSelected,
          idCliente: this.idCliente,
          idTipoProceso: this.procesoAltaSelected,
          codVisitaExt: this.codigoVisita,
          idOperador: this.operadorAltaSelected,
        }
        var buque = this.buquesAltaMOCK.find(n=> n.id == this.buqueAltaSelected).descripcion
        this.svcAverias.validarVisitaExistente(visita).subscribe(
          data => {
            if (data.body.idVisita != 0){
              alert(`El buque: ${buque} ya se encuentra asignado a una visita`)
              this.habilitarGuardar= false;
              this.resetearValores();
            }
            else{
              this.visitaNoExiste= true;
              this.habilitarUpload = true;
            }
          }
      )
      // VALIDAR EL BUQUE-TIPO PROCESO- FECHA NO ESTE DADO DE ALTA
  }
  changeFechaAltaETA(ev){
    // if (ev != null || ev != undefined){
    //   if (ev < this.diaTomorrow)
    //   {
    //     this.fechaAltaETA = this.diaTomorrow
    //     alert("La fecha debe ser mayor a 24 horas")
    //   }

    // }
  }
  changeFechaAltaATA(ev){
    // if (ev != null || ev != undefined){
    //   if (ev < this.diaTomorrow)
    //   {
    //     this.fechaAltaATA = this.diaTomorrow
    //     alert("La fecha debe ser mayor a 24 horas")
    //   }
    // }
  }
  changeFechaAltaETD(ev){
    // if (ev != null || ev != undefined){
    //   if (ev < this.diaTomorrow) {
    //     this.fechaAltaETD = this.diaTomorrow
    //     alert("La fecha debe ser mayor a 24 horas")
    //   }
    // }
  }
  changeFechaAltaATD(ev){
    // if (ev != null || ev != undefined){
    //   if (ev < this.diaTomorrow)
    //   {
    //     this.fechaAltaATD = this.diaTomorrow
    //     alert("La fecha debe ser mayor a 24 horas")
    //   }
    // }
  }
  limpiarArchivo = (event) => {
    event.target.value = ''
  }
  addfile(event) {
    this.showSpinnerUpload = true;
    var validExts = new Array(".xlsx", ".xls");
    var fileExt = event.srcElement.files[0].name;
    fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
    if (validExts.indexOf(fileExt) < 0) {
      alert("Archivo seleccionado inválido, debe ser de extensión tipo" +  validExts.toString());
      this.fileName = "";
      this.showSpinnerUpload = false;
      return;
    }

    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.file = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      this.fileName = target.files[0].name;

      this.cargarGrillaAlta();
      this.ingresarDatosGrillaAlta();
      this.habilitarBotonGuardar();
    };
  }
  guardarVisita(){
    if (this.procesoAltaSelected == 1){
      if ((this.fechaAltaETA == null && this.fechaAltaATA == null)
      || (this.fechaAltaETA == undefined && this.fechaAltaATA == undefined)){
        alert("Debe completar la fecha de ETA o ATA")
        return
      }
    }

    if (this.procesoAltaSelected == 2){
      if ((this.fechaAltaETD == null && this.fechaAltaATD == null)
      || (this.fechaAltaETD == undefined && this.fechaAltaATD == undefined))
      {
        alert("Debe completar la fecha de ETD o ATD")
        return
      }
    }

    var visitaVins: vinsVisitaDTO =
    {
      idBuque: this.buqueAltaSelected, 
      idCliente: this.idCliente, 
      codVisitaExterno: this.codigoVisita,
      idOperador: this.operadorAltaSelected,
      idTipoProceso: this.procesoAltaSelected, 
      ETD: this.fechaAltaETD, 
      ETA: this.fechaAltaETA, 
      ATA: this.fechaAltaATA, 
      ATD: this.fechaAltaATD, 
      vins: this.vinsDeLaVisita
    }
    this.showSpinnerGuardar =true;
    this.svcAverias.saveVisita(visitaVins).subscribe(
      data => {
        if (data["status"] == 200) {
          this.openSnackBar('Los cambios se han guardado correctamente');
          //gtag Alta
          this.svcAnalytics.setAnalyticsAltaButton();
          this.resetearValoresGuardar();
        } else {
          this.openSnackBar('Ha ocurrido un error al guardar los datos');
        }
        this.showSpinnerGuardar = false;
      }, error=>{
        this.openSnackBar('Ha ocurrido un error al guardar los datos');
        this.showSpinnerGuardar= false;
      }
    )
  }
  refreshMetrics(args) {
    if (args && args.current >= 0) {
      setTimeout(() => {
        this.elemFiltered = args.dataView.getFilteredItems().length;
      });
    }
  }
  openSnackBar(mensaje: string) {
    console.log(mensaje)
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }

  openVinsIspeccDialog(data, descipciontitulo, filename) {
    const dialogRef = this.dialogService.open(VinsBuquesPopupValidExpoComponent, {
      context: { dialogData : data , title: descipciontitulo, namefilexls: filename },
    });
  }

    onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
  
  }
}
